export default "__VITE_ASSET__FH2oHHxt__"